const SERVER_IP = 'https://nada.gtechclick.cloud'; // Live
//const SERVER_IP = 'http://localhost:5002'; // demo

export const API_ENDPOINTS = {
  
  // User APIs
  getAllUsers: `${SERVER_IP}/getalluserDetails`, // Fetch all user details
  deleteUser: `${SERVER_IP}/deleteUser`,        // Delete a user
  editUser: `${SERVER_IP}/editUser`,  
  changepassword: `${SERVER_IP}/changepassword`, 
    changepasswordProvider: `${SERVER_IP}/changepasswordProvider`,                    
  toggleUserActiveStatus: `${SERVER_IP}/toggleUserActiveStatus`, // Toggle user active status

   
  // Order APIs 
  getAllOrders: `${SERVER_IP}/getAllOrders`, 
  deleteOrder: `${SERVER_IP}/deleteOrder`,   // Fetch all orders 
  updateOrder: `${SERVER_IP}/updateorder`, 
    
  // Product APIs
  createProduct: `${SERVER_IP}/createProduct`,  // Create a new product
  getAllProducts: `${SERVER_IP}/getAllProductslist`, // Fetch list of all products
  getProductById: `${SERVER_IP}/getProductById`,  // Fetch product by its ID
  deleteProduct: `${SERVER_IP}/deleteProduct`,    // Delete a product
  editProduct: `${SERVER_IP}/editProduct`,        // Edit product details
  
  // Appointment APIs
  getAppointments: `${SERVER_IP}/getAppointments`,  // Fetch all appointments
  
  // Billing APIs
  updateBillingAmount: `${SERVER_IP}/updateBillingAmount`, // Update billing amount
  fetchProviderBillingDetails: `${SERVER_IP}/fetchProviderBillingDetails`, // Fetch billing details for a provider
  withdrawalRequest: `${SERVER_IP}/withdrawalRequest`, // Submit a withdrawal request
  getAllBillings: `${SERVER_IP}/getAllBillings`,  // Fetch all billing details
  getWithdrawalRequests: `${SERVER_IP}/getWithdrawalRequests`, // Fetch withdrawal requests 
  updateWithdrawalRequestStatus: `${SERVER_IP}/updateWithdrawalRequestStatus`, 

  getAllTransection: `${SERVER_IP}/getAllPaymentfromStrip`, 
 
  // Admin Login
  adminLogin: `${SERVER_IP}/admins/adminlogin`,  // Admin login endpoint

  // Plan APIs
  listAllPlans: `${SERVER_IP}/listAllPlans`,    // Fetch all plans
  deletePlan: `${SERVER_IP}/deletePlan`,        // Delete a plan
  editPlan: `${SERVER_IP}/editPlan`,            // Edit plan details
  addPlan: `${SERVER_IP}/addPlan`,              // Add a new plan

  // Provider APIs
  getAllProviders: `${SERVER_IP}/providerDetailsList`,  // Fetch all providers
  deleteProvider: `${SERVER_IP}/deleteUser`,    // Delete a provider
  editProviderBusiness: `${SERVER_IP}/editProviderBusiness`,
  

  // Service APIs
  listAllServices: `${SERVER_IP}/listAllServices`,      // Fetch all services
  deleteService: `${SERVER_IP}/deleteService`,          // Delete a service
  editService: `${SERVER_IP}/editService`,              // Edit service details
  addService: `${SERVER_IP}/addService`,                // Add a new service

  // Blog APIs
  createBlog: `${SERVER_IP}/createBlog`,                // Create a new blog
  editBlog: `${SERVER_IP}/editBlog`,                    // Edit blog details
  deleteBlog: `${SERVER_IP}/deleteBlog`,                // Delete a blog
  fetchBlogs: `${SERVER_IP}/blogs`,                     // Fetch all blogs

  // Subscription APIs
  getAllSubscriptionDetails: `${SERVER_IP}/getAllSubscriptionDetails`, // Fetch subscription details
  deleteSubscription: `${SERVER_IP}/deleteSubscription`,   // Delete a subscription
  editSubscription: `${SERVER_IP}/editSubscription`,       // Edit subscription details

  // Mental Health Video APIs
  getAllMentalHealthVideos: `${SERVER_IP}/getAllMentalHealthVideos`, // Fetch all mental health videos
  deleteMentalHealthVideo: `${SERVER_IP}/deleteMentalHealthVideo`,   // Delete a mental health video
  addMentalHealthVideo: `${SERVER_IP}/addMentalHealthVideo`,         // Add a new mental health video
  updateMentalHealthVideo: `${SERVER_IP}/updateMentalHealthVideo`,   // Update a mental health video

  // Video APIs
  getAllVideos: `${SERVER_IP}/listAllVideos`,              // Fetch all videos
  addVideo: `${SERVER_IP}/addVideo`,                      // Add a new video
  editVideo: `${SERVER_IP}/editVideo`,                    // Edit video details
  deleteVideo: `${SERVER_IP}/deleteVideo`,                // Delete a video
  
  // Category & Subcategory APIs
  listAllCategories: `${SERVER_IP}/listAllCategories`,    // Fetch all categories
  listAllSubCategories: `${SERVER_IP}/listAllSubCategories`, // Fetch all subcategories
  listAllSubCategoriesAdmin: `${SERVER_IP}/listAllSubCategoriesAdmin`, // Fetch all subcategories
  addSubCategory: `${SERVER_IP}/addSubCategory`,          // Add a new subcategory

  // Count APIs
  countProviderBusinesses: `${SERVER_IP}/provider-count`, // Count of providers
  countAppointments: `${SERVER_IP}/appointments-count`,   // Count of appointments
  countUsers: `${SERVER_IP}/users-count`,                 // Count of users
  countOrders: `${SERVER_IP}/Orders-count`,               // Count of orders

  //Lab Service    
//    
  getAllLabServices: `${SERVER_IP}/getAllLaboratoryServices`, // Count of providers
  addLabService: `${SERVER_IP}/create-labservice`,   // Count of appointments
  updateLabService: `${SERVER_IP}/edit-labservice`,                 // Count of users 
  deleteLabService: `${SERVER_IP}/delete-labservice`,   
  getProviderServices: `${SERVER_IP}/getProviderServiceByProviderId`,

};
